<template>
<div class="margin-tab">
    <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist"> <!---{{ modoDark_var }} - {{ itemActive }}--->
      <a
        class="nav-link"
        @click="itemActive = true"
        :class="[
            (!modoDark_var && itemActive)? 'active' : '',
            (modoDark_var && itemActive)? 'DarkActive active' : '',
            (modoDark_var && itemActive==false)? 'darkInactivo' : ''
        ]"
        id="nav-home-tab"
        data-toggle="tab"
        href="#nav-home"
        role="tab"
        aria-controls="nav-home"
        aria-selected="true"
      >
       Ley de ingresos
      </a>
      <a
        class="nav-link"
        @click="itemActive = false"
        :class="[
                (!modoDark_var && !itemActive)? 'active' : '',
                (modoDark_var && itemActive==false)? 'DarkActive active' : '',
                (modoDark_var && itemActive==true)? 'darkInactivo' : ''
        ]"
        id="nav-profile-tab"
        data-toggle="tab"
        href="#nav-profile"
        role="tab"
        aria-controls="nav-profile"
        aria-selected="false"
    >
      Presupuesto de Egresos
    </a>
    </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
    <div :class="[(itemActive)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
        <div class="card">
            <div class="card-body">
                <div class="row card-body">
                    <div class="container text-left mb-3">
                            <h6>Ley de ingresos del Estado de Chiapas</h6>
                        </div>
                    <div class="col-7">
                        <select v-model="selected" class="custom-select custom-select-lg">
                            <option>Consultar año</option>
                            <option>2026</option>
                            <option>2025</option>
                            <option>2024</option>
                            <option>2023</option>
                            <option>2022</option>
                            <option>2021</option>
                            <option>2020</option>
                            <option>2019</option>
                            <option>2018</option>
                            <option>2017</option>
                            <option>2016</option>
                            <option>2015</option>
                            <option>2014</option>
                            <option>2013</option>
                            <option>2012</option>
                            <option>2011</option>
                            <option>2010</option>
                            <option>2009</option>
                            <option>2008</option>
                            <option>2007</option>
                            <option>2006</option>
                            <option>2005</option>
                            <option>2004</option>
                        </select>
                    </div>
                    <div class="col-5">
                        <button @click="consulta1" class="btn btn-vino btn-block">Generar PDF</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div :class="[(!itemActive)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
        <div class="card">
            <div class="card-body">
                <div class="row card-body">
                        <div class="container text-left mb-3">
                            <h6>Presupuesto de Egresos del Estado de Chiapas</h6>
                        </div>
                    <div class="col-7">
                        <select v-model="selected2" class="custom-select custom-select-lg">
                            <option>Consultar año</option>
                            <option>2026</option>
                            <option>2025</option>
                            <option>2024</option>
                            <option>2023</option>
                            <option>2022</option>
                            <option>2021</option>
                            <option>2020</option>
                            <option>2019</option>
                            <option>2018</option>
                            <option>2017</option>
                            <option>2016</option>
                            <option>2015</option>
                            <option>2014</option>
                            <option>2013</option>
                            <option>2012</option>
                            <option>2011</option>
                            <option>2010</option>
                            <option>2009</option>
                            <option>2008</option>
                            <option>2007</option>
                            <option>2006</option>
                        </select>
                    </div>
                    <div class="col-5">
                        <button @click="consulta2" class="btn btn-vino btn-block">Generar PDF</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
</template>
<script>
import { mapState } from "vuex";
export default {
    data: function(){
        return{
            selected: 'Consultar año',
            selected2: 'Consultar año',
            itemActive: true
        }
    },
    methods:{
        consulta1(){
            var urlServe = this.urlServe;
            if(this.selected > 1){
                if(this.selected == '2004'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2004.pdf', '_blank');
                }
                else if(this.selected == '2005'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2005.pdf', '_blank');
                }
                else if(this.selected == '2006'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2006.pdf', '_blank');
                }
                else if(this.selected == '2007'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2007.pdf', '_blank');
                }
                else if(this.selected == '2008'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2008.pdf', '_blank');
                }
                else if(this.selected == '2009'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2009.pdf', '_blank');
                }
                else if(this.selected == '2010'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2010.pdf', '_blank');
                }
                else if(this.selected == '2011'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2011.pdf', '_blank');
                }
                else if(this.selected == '2012'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2012.pdf', '_blank');
                }
                else if(this.selected == '2013'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2013.pdf', '_blank');
                }
                else if(this.selected == '2014'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2014.pdf', '_blank');
                }
                else if(this.selected == '2015'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2015.pdf', '_blank');
                }
                else if(this.selected == '2016'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2016.pdf', '_blank');
                }
                else if(this.selected == '2017'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2017.pdf', '_blank');
                }
                else if(this.selected == '2018'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2018.pdf', '_blank');
                }
                else if(this.selected == '2019'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2019.pdf', '_blank');
                }
                else if(this.selected == '2020'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2020.pdf', '_blank');
                }
                else if(this.selected == '2021'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2021.pdf', '_blank');
                }
                else if(this.selected == '2022'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2022.pdf', '_blank');
                }
                else if(this.selected == '2023'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2023.pdf', '_blank');
                }
                else if(this.selected == '2024'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2024.pdf', '_blank');
                }
                else if(this.selected == '2025'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2025.pdf', '_blank');
                }
                else if(this.selected == '2026'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Leyes/LI2026.pdf', '_blank');
                }
            }
        },

        consulta2(){
            var urlServe = this.urlServe;
            // console.log(this.selected2);
            if(this.selected2 > 1){
                if(this.selected2 == '2006'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto06.pdf', '_blank');
                }
                else if(this.selected2 == '2007'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto07.pdf', '_blank');
                }
                else if(this.selected2 == '2008'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto08.pdf', '_blank');
                }
                else if(this.selected2 == '2009'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto09.pdf', '_blank');
                }
                else if(this.selected2 == '2010'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto10.pdf', '_blank');
                }
                else if(this.selected2 == '2011'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto11.pdf', '_blank');
                }
                else if(this.selected2 == '2012'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto12.pdf', '_blank');
                }
                else if(this.selected2 == '2013'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto13.pdf', '_blank');
                }
                else if(this.selected2 == '2014'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto14.pdf', '_blank');
                }
                else if(this.selected2 == '2015'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto15.pdf', '_blank');
                }
                else if(this.selected2 == '2016'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto16.pdf', '_blank');
                }
                else if(this.selected2 == '2017'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto17.pdf', '_blank');
                }
                else if(this.selected2 == '2018'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto18.pdf', '_blank');
                }
                else if(this.selected2 == '2019'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto19.pdf', '_blank');
                }
                else if(this.selected2 == '2020'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto20.pdf', '_blank');
                }
                else if(this.selected2 == '2021'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto21.pdf', '_blank');
                }
                else if(this.selected2 == '2022'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto22.pdf', '_blank');
                }
                else if(this.selected2 == '2023'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto23.pdf', '_blank');
                }else if(this.selected2 == '2024'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto24.pdf', '_blank');
                }
              else if(this.selected2 == '2025'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto25.pdf', '_blank');
              }
              else if(this.selected2 == '2026'){
                    window.open(urlServe+'marco-juridico/Estatal/informacion/Decretos/decreto26.pdf', '_blank');
              }
            }

        }
    },
    watch:{
        // selected: function(){
            // if(this.selected > 1){
            //     console.log(this.selected);
            // }
        // }
    },
    computed:{ ...mapState(['modoDark_var']) }
}
</script>
<style scoped>
.nav-link{ color: #621132 !important; }
.darkInactivo{ color: white !important; }

.margin-tab{ width: 90%; }
.nav-tabs {
    border-bottom: none;
    justify-content: end;
 }
.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
    color: #621132;
}
a{ color: #4d4d4d;}
a:hover { color: #ad0d33 !important; }  /**color: #992e5a !important; */
.card-body { min-height: 1px; }
h6{ font-weight: 400; }

@media only screen and (max-device-width : 900px) {
    a { font-size: 14px; }

    h6 { font-size: 13px; }

    .form-control-lg {
        padding: .5rem .3rem;
        font-size: 0.9rem;
    }

    .btn{
        padding: .5rem .9rem;
        font-size: .7rem;
    }

    /* propiedades del card de consultar año */
    .card-body{ padding: .8rem; }
    .col-7{
        padding-right: 5px !important;
        padding-left: 5px !important;
    }
    .col-5{
        padding-right: 5px !important;
        padding-left: 5px !important;
    }

    .sec_imagen { margin-left: 0 !important; }
    .nav{flex-wrap: nowrap;}

}


</style>
